import { batchNumberSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const batchNumberReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case batchNumberSelectors.GET_BATCH_NUMBER:
      return {
        ...state,
        loading: true,
      };
    case batchNumberSelectors.GET_BATCH_NUMBER_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
